import "./_content.scss";

import DOMPurify from "dompurify";
import {useEffect, useState} from "react";
import {ReactElement} from "react";

import {getActualite} from "@/api/actualite";
import {getPage} from "@/api/pageContent";
import Title from "@/components/Section/Title";
import {detailActualite} from "@/types/actualite";
import {pageContent} from "@/types/pageContent";

import CarteEmploye from "../CarteEmploye/CarteEmploye";

function Content({
  idPage,
  idArticle,
}: {
  idPage?: string;
  idArticle?: string;
}): ReactElement {
  const [page, setPage] = useState<pageContent | null>(null);
  const [actu, setActu] = useState<detailActualite | null>(null);

  useEffect(() => {
    const callPage = async (): Promise<void> => {
      if (idPage) {
        const response = await getPage(idPage);
        setPage(response);
      } else if (idArticle) {
        const response = await getActualite(idArticle);
        setActu(response);
      }
    };
    callPage();
  }, [idPage]);

  const employees = actu?.carteEmploye.map(employee => {
    return <CarteEmploye employe={employee} key={employee.id} />;
  });
  return (
    <div id="page-content">
      {page
        ? page?.sections?.map(section => {
            return (
              <div className="page-content-section" key={section.id}>
                <Title title={section.title} />
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(section.content),
                  }}
                />
              </div>
            );
          })
        : null}
      {actu ? (
        <>
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(actu.contenu),
            }}
          />
          {employees}
        </>
      ) : null}
    </div>
  );
}

export default Content;
